import {createAction} from "@reduxjs/toolkit";
export const updateRanges = createAction('continuous/updateRanges');
export const updateOneOrientation = createAction('continuous/updateOneOrientation');